<cap-select-button [formControl]="formControl"
                [optionLabel]="field.props.optionLabel ? field.props.optionLabel : 'label'"
                [dataKey]="field.props.dataKey ? field.props.dataKey : 'value'"
                [formlyAttributes]="field"
                [options]="field.props.options | observablePipe | async">
</cap-select-button>
